import { ReactNode, useState } from "react";
import { Box, styled } from "@mui/material";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileMenu } from "./MobileMenu";

const LayoutContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  background: "var(--background-white)",
});

const MainContent = styled(Box)(({ theme }) => ({
  marginTop: "75px",
  backgroundColor: "var(--background-content)",
  flex: 1,
  width: "100%",
  [theme.breakpoints.up("md")]: {
    padding: "0 12px",
  },
}));

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <LayoutContainer>
      <Header onMenuClick={handleMenuOpen} />
      <MainContent>{children}</MainContent>
      <Footer />
      <MobileMenu open={mobileMenuOpen} onClose={handleMenuClose} />
    </LayoutContainer>
  );
};
